import { CompetitionResultsListTable } from './components/competition-results-table';
import { ConfirmDialog } from '~/components/ConfirmDialog/ConfirmDialog';
import { PersonalBestTable } from './components/personal-best-table';
import { ContextMenu } from '~/components/ContextMenu/ContextMenu';
import { useDeletePersonMutation } from '~/pages/person/mutations';
import { LifterBasicInfo } from './components/lifter-basic-info';
import { PageLayout } from '~/components/PageLayout/PageLayout';
import { usePersonDetailsQuery } from '~/pages/person/queries';
import { useAuthentication } from '~/hooks/useAuthentication';
import { ResultsChart } from './components/results-chart';
import { Button } from '~/components/Button/Button';
import { insertOnCondition } from '~/utils/array';
import { useParams } from '~/hooks/useParams';
import { useDialog } from '~/hooks/useDialog';
import { Fragment } from 'react/jsx-runtime';
import { useNavigate } from 'react-router';
import { idParamSchema } from '~/schemas';

export function Page() {
  const { id } = useParams(idParamSchema.parse);
  const { data } = usePersonDetailsQuery(id);
  const { can } = useAuthentication();

  const deleteMutation = useDeletePersonMutation();
  const navigate = useNavigate();
  const dialog = useDialog();

  async function handleDelete() {
    await deleteMutation.mutateAsync(id);
    navigate('..');
  }

  if (!data) {
    return false;
  }

  return (
    <Fragment>
      <PageLayout.Header>
        {data && <PageLayout.Heading text={`${data.first_name}  ${data.last_name} (${data.is_male ? 'H' : 'D'})`} />}

        <Button.Group neutral>
          {can('list-lifter-license', data.club.id) && (
            <Button type="button" onClick={() => navigate('licenses')}>
              Licenser
            </Button>
          )}

          <PageLayout.Context
            items={[
              ...insertOnCondition(
                <ContextMenu.Item label="Redigera" to="edit" key="edit" />,
                can('edit-lifter', data.club.id)
              ),
              ...insertOnCondition(
                <ContextMenu.Item label="Ta bort" onClick={dialog.open} key="delete" danger />,
                can('delete-lifter')
              ),
            ]}
          />
        </Button.Group>
      </PageLayout.Header>

      <PageLayout.Section>
        <LifterBasicInfo
          person={{
            club: data?.club,
            license_id: data.license_id,
            is_para: data.is_para,
            is_ifn: data.is_ifn,
          }}
        />
      </PageLayout.Section>

      <PageLayout.Section>
        <PersonalBestTable pbs={data?.personal_bests} isLoading={false} />
      </PageLayout.Section>

      <PageLayout.Section>
        <ResultsChart results={data?.results} isLoading={false} />
      </PageLayout.Section>

      <PageLayout.Section>
        <CompetitionResultsListTable results={data?.results} isLoading={false} />
      </PageLayout.Section>

      <ConfirmDialog isLoading={deleteMutation.isPending} onConfirm={handleDelete} {...dialog} />
    </Fragment>
  );
}
